<div class="responsive-contr">
  <div class="container mob body">
    <div class="download">
      <div class="row">
        <div class="col-4">
          <div
            class="app-logo"
            style="
              background-image: url(../../../../assets/images/nadel-icon.webp);
            "></div>
        </div>
        <div class="col-8">
          <div class="app-header has-logo pt-4">
            <h1>Nadel Sales Mobile App</h1>
          </div>
        </div>
      </div>
      <div class="col-lg-12 pt-4">
        <a href="/sales-mobile-app" class="back-link router-link-active"
          >Go back</a
        >
        <h3>
          <svg
            aria-hidden="true"
            focusable="false"
            data-prefix="fas"
            data-icon="info-circle"
            role="img"
            viewBox="0 0 512 512"
            class="icon svg-inline--fa fa-info-circle fa-w-16">
            <path
              fill="currentColor"
              d="M256 8C119.043 8 8 119.083 8 256c0 136.997 111.043 248 248 248s248-111.003 248-248C504 119.083 392.957 8 256 8zm0 110c23.196 0 42 18.804 42 42s-18.804 42-42 42-42-18.804-42-42 18.804-42 42-42zm56 254c0 6.627-5.373 12-12 12h-88c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h12v-64h-12c-6.627 0-12-5.373-12-12v-24c0-6.627 5.373-12 12-12h64c6.627 0 12 5.373 12 12v100h12c6.627 0 12 5.373 12 12v24z"
              class=""></path></svg
          >Instructions
        </h3>
        <ol class="instructions">
          <li>
            Accept the download and wait for it to finish.
            <img
              src="../../../../assets/images/android-step-1.png"
              class="instruction-image"
              alt="" />
          </li>
          <li>
            Open the app file once it has downloaded. You may see an
            announcement at the bottom of your screen like this one, or you
            might have to open your Files app.
            <img
              src="../../../../assets/images/android-step-2.png"
              class="instruction-image"
              alt="" />
          </li>
          <li>
            Once you open the app, Android will request permission to install
            it. Click "install" and you're good to go!
            <svg
              class="permission-name-overlay"
              viewBox="0 0 631 302"
              class="instruction-image">
              <image
                xlink:href="../../../../assets/images/android-step-3.png"
                width="100%"
                height="100%"
                x="0"
                y="0"></image>
              <text x="60" y="58" font-size="38">Nadel Mobile App</text>
            </svg>
          </li>
        </ol>
      </div>
    </div>
  </div>
</div>
